@if (device$ | async; as device) {
  <div class="main-container">
    <app-card class="flex-2" [loading]="(loading$ | async) ?? false">
      <div class="header">
        <button type="button" class="button icon-button" (click)="onBack()">
          <app-icon name="ic_chevron_left" />
          <span class="hidden-on-mobile">{{ "default.back" | translate }}</span>
        </button>

        <div class="actions">
          <button type="button" class="button icon-button" (click)="onEdit()">
            <app-icon name="ic_edit" />
            {{ "default.edit" | translate }}
          </button>
          <button
            type="button"
            class="button icon-button"
            (click)="onToggleFavorite(device)"
          >
            @if (device.isFavorite) {
              <app-icon class="color-favorite" name="ic_star_filled" />
            } @else {
              <app-icon name="ic_star" />
            }
          </button>
          <app-context-menu [menuItems]="getContextMenu(device)" />
        </div>
      </div>

      <div class="flex gap-4">
        <h2>
          <app-text-with-icon [name]="device.type | icons">{{
            device.name
          }}</app-text-with-icon>
        </h2>
        @if (device.isOutOfService) {
          <app-tag class="ml-2" level="disabled">
            {{ "devices.detail.outOfService.label" | translate }}
          </app-tag>
        } @else if (device.isActuator) {
          @let isActive = (isActive$ | async) ?? false;
          @let killSwitch = (killSwitch$ | async) ?? false;
          @let isOutOfService = device.isOutOfService ?? false;
          <app-device-action-trigger
            [disabled]="
              isActive ? isOutOfService : isOutOfService || !killSwitch
            "
            size="lg"
            [isActive]="isActive"
            [isPending]="isDevicePending(device)"
            (triggerDeviceAction)="onTriggerDeviceAction($event.value)"
          />
        }
      </div>

      <section class="grid grid-cols-2 align-start">
        <app-device-info-table [device]="device">
          @if (shouldShowValveTargetType(device)) {
            <tr>
              <th>{{ "devices.detail.targetType" | translate }}</th>
              <td>
                {{ getTargetTypeLabelKey(device.deviceTargetType) | translate }}
              </td>
            </tr>
          }
        </app-device-info-table>
        <div>
          @if (device.sourcePump) {
            <section>
              <p class="bold mb-1">
                {{ "devices.detail.sourcePump" | translate }}
              </p>
              <app-device-item-card
                [device]="device.sourcePump"
                [description]="'devices.detail.sourcePump' | translate"
              />
            </section>
          }

          @if (connectedCistern$ | async; as connectedCistern) {
            <section>
              <p class="bold mb-1">
                {{ "devices.detail.cistern" | translate }}
              </p>
              <app-cistern-item-card
                [cistern]="connectedCistern"
                [navigateToDetail]="true"
                [withAnimation]="false"
              />
            </section>
          }

          @if (targetCistern$ | async; as targetCistern) {
            <section>
              <p class="bold mb-1">
                {{ "devices.detail.targetCistern" | translate }}
              </p>
              <app-cistern-item-card
                [cistern]="targetCistern"
                [deviceFullAt]="device.fullAt | relativeDate"
                [navigateToDetail]="true"
                [withAnimation]="false"
              />
            </section>
          }
        </div>
      </section>
    </app-card>

    @let isUsableInRule = (isUsableInRule$ | async) ?? false;
    @let deviceGroups = (deviceGroups$ | async) ?? [];
    @if (isUsableInRule || deviceGroups.length) {
      <div class="flex-1 grid grid-cols-auto">
        @if (isUsableInRule) {
          <app-device-rules-card
            [rules]="(ruleList$ | async) ?? []"
            [disabled]="device.isOutOfService ?? false"
            (createRule)="onCreateRule()"
          />
        }

        @if (deviceGroups.length) {
          <app-card>
            <div class="header">
              <h3>{{ "devices.detail.groups" | translate }}</h3>
            </div>

            <div class="device-wrapper content grid grid-cols-1">
              @for (group of deviceGroups; track group.id) {
                <app-area-item-card
                  [deviceGroup]="group"
                  [isExpanded]="false"
                  [hideActions]="true"
                />
              }
            </div>
          </app-card>
        }
      </div>
    }
  </div>

  <div class="detail-container">
    <app-map-with-location
      class="map-wrapper"
      [navigateToMaps]="true"
      [device]="getMapDevice(device)"
    />
    @if (isUsableInRule$ | async) {
      @if (history$ | async; as history) {
        <app-history
          class="flex-1"
          [history]="history.data"
          [loading]="history.loading"
          [canLoadMore]="history.canLoadMore"
          (loadMore)="onLoadMoreHistory()"
        />
      }
    }

    <!--    todo include in another release-->
    <!--    <button type="button" class="button icon-button" (click)="onDelete()">-->
    <!--      <app-text-with-icon name="ic_delete">{{ 'devices.remove' | translate }}</app-text-with-icon>-->
    <!--    </button>-->
  </div>
} @else {
  <app-not-found [error]="getError()" [loading]="(loading$ | async) ?? false" />
}
